import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class DeactivateSnapshotControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const store = this.props.store;

    if (store.deactivateSnapshot === null)
      return null;

    const deactivate = store.deactivateSnapshot;
    const isFailure = deactivate.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deactivating" state={deactivate.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={store.completeDeactivateSnapshot}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
